module.exports = __webpack_public_path__ + "static/media/feature1.83801cc4.png";